import { render, staticRenderFns } from "./SecondAttempCards.vue?vue&type=template&id=fad55f7a&scoped=true&"
import script from "./SecondAttempCards.vue?vue&type=script&lang=js&"
export * from "./SecondAttempCards.vue?vue&type=script&lang=js&"
import style0 from "./SecondAttempCards.vue?vue&type=style&index=0&id=fad55f7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad55f7a",
  null
  
)

export default component.exports